import { styled } from "@mui/material/styles";
import { RadioGroup, Typography, CardActionArea, Box } from "@mui/material";
import Iconify from "../../Iconify";
import { useTool } from "../../../contexts/ToolContext";
import { useTranslation } from "react-i18next";
import BoxMask from "./BoxMask";
import { useFurnitureStore } from "../../../contexts/SelectedVariantContext";
import usePlannerSettings from "../../../contexts/PlannerContext";
import {useEffect} from "react";

const PillStyle = styled(CardActionArea)(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: 32,
  padding: "0 12px",
  border: "1.5px solid #31AB56",
  borderRadius: 16,
  color: "#31AB56",
  backgroundColor: "transparent",
  transition: "background-color 0.2s, color 0.2s",
  "&:hover": {
    backgroundColor: "rgba(49,171,86,0.1)",
  },
}));

export default function SettingPlannerInstrument() {
  const { toolName, onChangeTool, setIsRubber, setIsProjection, resetTool } = useTool();
  const resetVariant = useFurnitureStore((s) => s.resetVariant);
  const { complementiAttivi } = usePlannerSettings();
  const { t } = useTranslation();

  const handleChange = (e, val) => {
    resetVariant();
    setIsRubber(false);
    setIsProjection(false);

    switch (val) {
      case "rubber":
        setIsRubber(true)
        onChangeTool(100, [[0, 0]], "rubber");
        break;
      case "projection":
        setIsProjection(true)
        onChangeTool(null, null, "projection");
        break;
      case "rotate":
        onChangeTool(null, null, "rotate");
        break;
      case "move":
        onChangeTool(null, null, "move");
        break;
      default:
        break;
    }
  };

  const isSelected = (tool) => toolName === tool;

  const instruments = [
    { tool: "rubber", icon: "edit-off", name: t("settings.drawer.instruments.items.rubber"),  visible: true  },
    { tool: "move", icon: "open-with", name: t("settings.drawer.instruments.items.move"), visible: true  },
    { tool: "projection", icon: "straighten", name: "Misure", visible: !complementiAttivi },
    { tool: "rotate", icon: "rotate-right", name: t("settings.drawer.instruments.items.rotate"),  visible: !!complementiAttivi  },
  ];

  useEffect(() => {
    instruments.forEach(instr => {
      if (isSelected(instr.tool) && !instr.visible) {
        resetTool()
      }
    })
  }, [instruments, isSelected, resetTool])

  return (
      <RadioGroup name="themePlannerTool" value={toolName} onChange={handleChange}>
        <Box sx={{ display: "flex", gap: complementiAttivi ? "16px" : "8px", mt: 1 }}>
          {instruments
              .filter((item) => item.visible)
              .map(({ tool, icon, name }) => (
                  <PillStyle
                      key={tool}
                      sx={
                        isSelected(tool)
                            ? {
                              backgroundColor: "#31AB56",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#31AB56" },
                            }
                            : {}
                      }
                  >
                    <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                      {t(`settings.drawer.instruments.items.${tool}`)}
                    </Typography>
                    <Box sx={{ ml: 0.5 }}>
                      <Iconify icon={`material-symbols:${icon}`} width={20} height={20} />
                    </Box>
                    <BoxMask value={tool} />
                  </PillStyle>
              ))}
        </Box>
      </RadioGroup>
  );
}
